import { AddPaymentDocument } from './AddPaymentDocument';

export {
  PaymentDocumentsRegistry,
  PaymentDocumentsRegistryHeader,
} from './PaymentDocumentsRegistry';
export { AddPaymentDocument };
